import { QueryFunctionContext } from '@tanstack/react-query';
import { ServiceInvoice } from 'types';
import { baseQuery } from '../baseQuery';

export const getServiceInvoice = async ({
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<ServiceInvoice[]> => {
  const serviceId = queryKey[1];
  const { data } = await baseQuery(`service-invoice/${serviceId}`);

  return data;
};
